const tableTitleServiceType = {
  title: 'Service Types',
  placeholder: 'Search by Service Types',
  Typography: 'No results found'
};

export default tableTitleServiceType;
